/**
 * Admin Dashboard Configuration
 * Provides default values for dashboard metrics, SLA thresholds, form defaults, and messages
 * Can be overridden by values from the database via the useAdminConfig hook
 */

export const ADMIN_DASHBOARD_CONFIG = {
  sla: {
    normalHours: 24,
    criticalHours: 48,
    breachedHours: 72,
  },
  disputes: {
    urgentResponseWindowHours: 2,
    performanceWindowDays: 7,
  },
  forms: {
    defaultDiscountType: 'Percentage',
    defaultAdminRole: 'System Administrator',
    defaultSuspensionReason: 'Security Review Required',
    defaultEscalationUrgency: 'HIGH',
  },
  messages: {
    jobScheduledSuccess: 'Job scheduled successfully',
    caseResolvedSuccess: 'Case resolved successfully',
    caseAssignedSuccess: 'Case assigned successfully',
    payoutReleasedSuccess: 'Payout released successfully',
  },
  payoutTabs: [
    { id: 'all', label: 'All' },
    { id: 'pending', label: 'Pending' },
    { id: 'held', label: 'Held' },
    { id: 'approved', label: 'Approved' },
    { id: 'processing', label: 'Processing' },
    { id: 'released', label: 'Released' },
    { id: 'disputed', label: 'Disputed' },
    { id: 'failed', label: 'Failed' },
  ],
};

export type AdminDashboardConfig = typeof ADMIN_DASHBOARD_CONFIG;
